// import { fileToBase64 } from '@/common/utils'
// import request from '@/http/api/base'

export default {
  name: "ImageUpload",
  props: {
    value: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      preview: false,
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
      }
    };
  },
  computed: {
    imageUrl() {
      return this.value;
      //   return `${process.env.VITE_APP_BASEURL}/dpmsgms${this.value}?token=${this.LS.get('token')}`
    }
  },
  methods: {
    async handleBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        if (file.size > 10485760) {
          this.$Message.warning($t("llf3x3b", "上传文件不能超过10M"));
          reject(false);
        }
        if (file.type.indexOf("image") === -1) {
          this.$Message.warning($t("at77oq5", "请上传图片"));
          reject(false);
        }
        resolve();
        // let signPic = await fileToBase64(file)
        // let picFormat = file.name.split('.')[1]
        // let params = {
        //   hotelCode: this.LS.get('orgCode'),
        //   picFormat,
        //   signPic
        // }
        // let res = await request.upload(params, this.url)
      });
    },
    handleSuccess(res) {
      let {
        result,
        retVal
      } = res;
      if (result === 0) {
        this.$emit("input", retVal);
      } else {
        this.$Message.error($t("8j2gel6", "图片上传失败"));
      }
    },
    handleRemove() {
      this.$emit("input", "");
    },
    handleView() {
      this.preview = true;
    }
  }
};